import { CondominiumsPageFilter } from '@portal/models/advanced-filters';
import {
  getInstance,
  getCleanInstance,
} from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/account';

const CondominiumsApi = {
  getCondominiums: async (params?: CondominiumsPageFilter) => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL}/provisional-accounts`, {
      params,
    });

    return data;
  },

  getUrl: async (params: { fileExtension: string; fileName: string }) => {
    const instance = getInstance();
    const { data } = await instance.get(
      `${BASE_URL}/provisional-accounts/upload-url`,
      {
        params,
      }
    );

    return data;
  },

  getPreview: async (
    params: { bucketPath: string; preview: boolean },
    accountId: string
  ) => {
    const instance = getInstance();
    const { data } = await instance.post(
      `${BASE_URL}/provisional-accounts/import`,
      params,
      {
        headers: {
          'payment-account-id': accountId,
        },
      }
    );

    return data;
  },

  uploadFile: async (
    fileBody: File,
    fileExtension: string,
    urlToUpload: string
  ) => {
    const instance = getCleanInstance(urlToUpload);
    const { data } = await instance.put('', fileBody, {
      headers: {
        'Content-Type': `file/${fileExtension}`,
      },
    });

    return data;
  },

  getUploadLogList: async (params?: CondominiumsPageFilter) => {
    const instance = getInstance();
    const { data } = await instance.get(
      `${BASE_URL}/provisional-account-groups`,
      {
        params,
      }
    );

    return data;
  },

  AccountSwitch: async (documentNumber: string) => {
    const instance = getInstance();
    const { data } = await instance.post(`${BASE_URL}/switch`, {
      documentNumber,
    });

    return data;
  },
};

export default CondominiumsApi;
